
































import { defineComponent, ref } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { $t } from "@/lib/i18nHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/BaseInput";
import BaseSpinner from "@/components/BaseSpinner";
import CustomScroll from "@/components/CustomScroll";
import SearchUsers from "@/components/SearchUsers";

export default defineComponent({
  name: "SearchUsersWithDropdown",
  components: { BaseIcon, BaseInput, BaseSpinner, SearchUsers, CustomScroll, BaseAvatar },
  props: {
    value: { type: String, required: true },
    usersLoading: { type: Boolean, required: true },
    usersList: { type: Array as () => UserPublicData[], required: true, default: [] },
    label: { type: String, default: $t("") },
    hint: { type: String },
  },
  setup() {
    const showUsersList = ref(false);
    return {
      showUsersList,
    };
  },
});
